if (!process.env.VUE_APP_IS_WEB) {
  var MandateDB = require("../database/models/Mandate");
}

import MandateORM from "@/store/orm-axios/models/Mandate";

export default {
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MandateDB({ id: id, deleted: null })
          .fetch({
            withRelated: [
              {
                building_owner: query => {
                  query.where("deleted", null);
                },
              },
              {
                representant_owner: query => {
                  query.where("deleted", null);
                },
              },
              {
                representant_contact: query => {
                  query.where("deleted", null);
                },
              },
              {
                resolution_votes: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            let data = res.serialize();
            MandateORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH(meeting_id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MandateDB()
          .query({ where: { deleted: null, meeting_id: meeting_id } })
          .fetchAll({
            withRelated: [
              {
                building_owner: query => {
                  query.where("deleted", null);
                },
              },
              {
                representant_owner: query => {
                  query.where("deleted", null);
                },
              },
              {
                representant_contact: query => {
                  query.where("deleted", null);
                },
              },
              {
                resolution_votes: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            MandateORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .FETCH(meeting_id)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH(agencyId, queryParams, relatedId /** ???: queryParams, still needed here ?? */) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MandateDB()
          .query({ where: { agency_id: agencyId, deleted: null, meeting_id: relatedId } })
          .fetchAll({
            withRelated: [
              {
                building_owner: query => {
                  query.where("deleted", null);
                },
              },
              {
                representant_owner: query => {
                  query.where("deleted", null);
                },
              },
              {
                representant_contact: query => {
                  query.where("deleted", null);
                },
              },
              {
                resolution_votes: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            MandateORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .QUERY_FETCH(agencyId, queryParams, relatedId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item, forSendingNotifs = false) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new MandateDB(itemPost)
          .save()
          .then(res => {
            if (!forSendingNotifs) {
              MandateORM.insertOrUpdate({
                data: res.serialize(),
              });
            }
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .POST(item, forSendingNotifs)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item, save = true) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new MandateDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            if (save) {
              console.log("saveMandateInOrm");
              MandateORM.insertOrUpdate({
                data: res.serialize(),
              });
            }
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new MandateDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            MandateORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  MANDATE_CORRESPONDENCE_VOTING(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .MANDATE_CORRESPONDENCE_VOTING(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  MANDATE_GET_DEFAULT_INVITATION_BROADCAST(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .MANDATE_GET_DEFAULT_INVITATION_BROADCAST(meetingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  MANDATE_GET_MANUAL_INVITATION_BROADCAST(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .MANDATE_GET_MANUAL_INVITATION_BROADCAST(meetingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH_WITHOUT_RESOLUTION_VOTES(meeting_id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MandateDB()
          .query({ where: { deleted: null, meeting_id: meeting_id } })
          .fetchAll({
            withRelated: [
              {
                building_owner: query => {
                  query.where("deleted", null);
                },
              },
              {
                representant_owner: query => {
                  query.where("deleted", null);
                },
              },
              {
                representant_contact: query => {
                  query.where("deleted", null);
                },
              },
              {
                resolution_votes: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            MandateORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .FETCH_WITHOUT_RESOLUTION_VOTES(meeting_id)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_DOC_REQUESTS(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      //
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .GET_DOC_REQUESTS(id)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_DOCS_BY_MEETING(queryParams) {
    if (!process.env.VUE_APP_IS_WEB) {
      //
    } else {
      return new Promise((resolve, reject) => {
        MandateORM.api()
          .GET_DOCS_BY_MEETING(queryParams)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
